unit Unit1;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Types, WEBLib.Grids, WEBLib.ExtCtrls,
  Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Grids, WEBLib.ComCtrls, Vcl.Controls,
  WEBLib.REST, WEBLib.WebCtrls, WEBLib.PayPal;  // <-- moved "login" to implementation section

type
  TForm1 = class(TForm)
    WebPageControl1: TPageControl;
    Tab1: TTabSheet;
    Grid: TResponsiveGridPanel;
    WebPanelCustomer: TPanel;
    WebStringGridChats: TStringGrid;
    WebGridPanelSearch: TGridPanel;
    WebButtonNewChat: TButton;
    WebSearchEditChats: TSearchEdit;
    WebPanelChats: TPanel;
    WebPanelChatHeader: TPanel;
    WebLabelChatTitle: TLabel;
    WebPanelChatInput: TPanel;
    WebEditMessage: TEdit;
    WebButtonSend: TButton;
    WebHTMLDiv1: THTMLDiv;
    Tab2: TTabSheet;
    WebScrollBox1: TScrollBox;
    WebResponsiveGrid1: TResponsiveGrid;
    Tab3: TTabSheet;
    TabAccount: TTabSheet;
    WebGridPanelTop: TGridPanel;
    WebLabelContactName: TLabel;
    WebLabelCompanyName: TLabel;
    WebLabelBalance: TLabel;
    WebHttpRequestGetClient: THttpRequest;
    WebButtonLogin: TButton;
    WebHTMLDivPayPal: THTMLDiv;
    procedure WebFormCreate(Sender: TObject);
    procedure WebButtonLoginClick(Sender: TObject);
    procedure WebStringGridChatsClick(Sender: TObject);
    procedure WebButtonSendClick(Sender: TObject);
    procedure WebPayPal1PaymentDone(Sender: TObject;
      Args: TPayPalPaymentEventArgs);
  private
    FCompanyId: Integer;
    FContactId: Integer;
    FClientAccountId: Integer;
    FLoginEmail: string;
    FLoginInProgress: Boolean;
    FCurrentSessionId: Integer;
    FCurrentSessionKey: string;
    procedure StartLoginRequest(const AEmail: string);
    procedure HandleLoginResponse(const AResponse: string);
    procedure HandleLoginError(const AError: string);
    procedure LoadChats;
    procedure HandleChatsResponse(const AResponse: string);
    procedure HandleChatsError(const AError: string);
    procedure LoadChatMessages(ASessionId: Integer);
    procedure DisplayMessages(const AResponse: string);
    procedure SendChatMessage(ASessionId: Integer; const AMessage: string);
  public
  protected procedure LoadDFMValues; override; end;

var
  Form1: TForm1;

implementation

{$R *.dfm}

uses
  login;  // <-- your login form unit

procedure TForm1.WebButtonLoginClick(Sender: TObject);
var
  LoginForm: TForm2;
begin
  asm
    console.log('Login button clicked');
  end;
  
  // Don't open login form if request is in progress
  if FLoginInProgress then
  begin
    ShowMessage('Please wait, login in progress...');
    Exit;
  end;
  
  LoginForm := TForm2.CreateNew(
    procedure(AForm: TObject)
    begin
      // Popup styling
      LoginForm.Popup := True;
      LoginForm.PopupOpacity := 0.5;
      LoginForm.Border := fbDialogSizeable;
      LoginForm.Caption := 'Login';

      // Center within main form
      LoginForm.Left := (Application.MainForm.Width - LoginForm.Width) div 2;
      LoginForm.Top  := (Application.MainForm.Height - LoginForm.Height) div 2;

      // Show modally and handle result
      LoginForm.ShowModal(
        procedure(AModalResult: TModalResult)
        var
          Email: string;
          CallbackExecuted: Boolean;
        begin
          // Prevent multiple executions of this callback
          asm
            if (LoginForm.CallbackExecuted) {
              console.log('Callback already executed, skipping');
              return;
            }
            LoginForm.CallbackExecuted = true;
            CallbackExecuted = true;
          end;
          
          if AModalResult = mrOk then
          begin
            Email := Trim(LoginForm.WebEditEmail.Text);
            asm
              console.log('Email entered:', Email);
            end;
            if Email = '' then
              ShowMessage('Please enter an email.')
            else
              StartLoginRequest(Email);  // call n8n
          end;

          // Free popup instance
          LoginForm.Free;
        end);
    end);
end;


procedure TForm1.StartLoginRequest(const AEmail: string);
var
  EncodedEmail, URL: string;
begin
  // Prevent multiple simultaneous requests
  if FLoginInProgress then
  begin
    ShowMessage('Login request already in progress...');
    Exit;
  end;
  
  FLoginInProgress := True;
  FLoginEmail := AEmail;

  // URL-encode email
  asm
    var encoded = encodeURIComponent(AEmail);
    EncodedEmail = encoded;
  end;

  URL := 'https://n8n.wilsea.com/webhook/oversightData' +
         '?action=selectClientData&email=' + EncodedEmail;

  // Use native fetch API for better CORS handling
  asm
    console.log('Fetching URL:', URL);
    
    // Capture this reference for use in callbacks
    var form = this;
    
    // Set a timeout to reset the flag if request takes too long
    var timeoutId = setTimeout(function() {
      console.error('Request timeout - resetting flag');
      form.FLoginInProgress = false;
    }, 10000); // 10 second timeout
    
    fetch(URL, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit'
    })
    .then(function(response) {
      clearTimeout(timeoutId);
      console.log('Response status:', response.status);
      console.log('Response headers:', response.headers);
      if (!response.ok) {
        throw new Error('HTTP error ' + response.status);
      }
      return response.text();
    })
    .then(function(responseText) {
      console.log('Response text:', responseText);
      // Call the success handler
      form.HandleLoginResponse(responseText);
    })
    .catch(function(error) {
      clearTimeout(timeoutId);
      console.error('Fetch error:', error);
      // Call the error handler
      form.HandleLoginError(error.message || error.toString());
    });
  end;
end;

procedure TForm1.WebFormCreate(Sender: TObject);

begin

 asm
const clientIdFromApp = 'CLIENT_12345'; // put your own internal id if needed

    paypal.Buttons({
      createOrder: function (data, actions) {
        return actions.order.create({
          purchase_units: [
            {
              amount: {
                value: '0.01',
                currency_code: 'GBP'
              },
              custom_id: clientIdFromApp
            }
          ]
        });
      },
      onApprove: function (data, actions) {
        return actions.order.capture().then(function (details) {
          alert(
            'Thanks, ' +
              details.payer.name.given_name +
              '! Your PayPal payment of £0.01 was successful.'
          );
        });
      }
    }).render('#paypal-button-container'); // ElementID of WebHTMLDivPayPal
  end;


  WebButtonLogin.Caption := 'Login';
  WebLabelCompanyName.Caption := 'Company: (not logged in)';
  WebLabelContactName.Caption := 'Contact: -';
  WebLabelBalance.Caption     := 'Balance: -';

  FCompanyId := 0;
  FContactId := 0;
  FClientAccountId := 0;
  FLoginEmail := '';
  FLoginInProgress := False;
end;

procedure TForm1.WebPayPal1PaymentDone(Sender: TObject;
  Args: TPayPalPaymentEventArgs);
begin
    showmessage('payment recived' + Args.InvoiceNumber)
end;

procedure TForm1.HandleLoginError(const AError: string);
begin
  FLoginInProgress := False;
  ShowMessage('Login request failed: ' + AError);
end;

procedure TForm1.HandleLoginResponse(const AResponse: string);
var
  CompanyName, ContactName: string;
  Balance: Double;
  HasClient: Boolean;
begin
  // API returns an array, so parse the first element
  asm
    var data = JSON.parse(AResponse);
    var client = null;
    
    // Check if data is an array and has at least one element
    if (Array.isArray(data) && data.length > 0) {
      client = data[0];
    }

    if (client) {
      HasClient = true;
      this.FCompanyId       = client.company_id;
      this.FContactId       = client.contact_id;
      this.FClientAccountId = client.client_account_id;

      CompanyName = client.company_name;
      ContactName = client.contact_name;
      Balance     = parseFloat(client.balance_usd);
    } else {
      HasClient = false;
    }
  end;

  if not HasClient then
  begin
    FLoginInProgress := False;
    ShowMessage('No client data returned for this email.');
    Exit;
  end;

  FLoginInProgress := False;
  
  WebLabelCompanyName.Caption := 'Company: ' + CompanyName;
  WebLabelContactName.Caption := 'Contact: ' + ContactName;
  WebLabelBalance.Caption     :=
    'Balance: ' + FormatFloat('"$"0.00', Balance);

  // Load chats for this company
  LoadChats;
end;

procedure TForm1.LoadChats;
var
  URL: string;
begin
  if FCompanyId = 0 then
  begin
    ShowMessage('No company ID available');
    Exit;
  end;

  URL := 'https://n8n.wilsea.com/webhook/oversightData' +
         '?action=getChats&companyId=' + IntToStr(FCompanyId);

  asm
    console.log('Loading chats for company:', this.FCompanyId);
    console.log('Fetching URL:', URL);
    
    var form = this;
    
    fetch(URL, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit'
    })
    .then(function(response) {
      console.log('Chats response status:', response.status);
      if (!response.ok) {
        throw new Error('HTTP error ' + response.status);
      }
      return response.text();
    })
    .then(function(responseText) {
      console.log('Chats response:', responseText);
      form.HandleChatsResponse(responseText);
    })
    .catch(function(error) {
      console.error('Chats fetch error:', error);
      form.HandleChatsError(error.message || error.toString());
    });
  end;
end;

procedure TForm1.HandleChatsResponse(const AResponse: string);
var
  arr: TJSArray;
  o: TJSObject;
  i, r: Integer;
  
  function GetStr(const Key: string): string;
  var v: JSValue;
  begin
    v := o[Key];
    if JS.isUndefined(v) or JS.isNull(v) then
      Result := ''
    else
      Result := string(v);
  end;
  
  function GetInt(const Key: string): Integer;
  var v: JSValue;
  begin
    v := o[Key];
    if JS.isUndefined(v) or JS.isNull(v) then
      Result := 0
    else
      Result := Integer(v);
  end;
  
  function FormatCost(const Key: string): string;
  var 
    v: JSValue;
    cost: Double;
  begin
    v := o[Key];
    if JS.isUndefined(v) or JS.isNull(v) then
      Result := '$0.00'
    else
    begin
      cost := Double(v);
      Result := FormatFloat('"$"0.00', cost);
    end;
  end;
  
begin
  arr := TJSArray(TJSJSON.parse(AResponse));
  
  // Setup grid
  WebStringGridChats.ColCount := 4;
  WebStringGridChats.RowCount := arr.length + 1; // +1 for header
  
  // Set headers
  WebStringGridChats.Cells[0, 0] := 'Title';
  WebStringGridChats.Cells[1, 0] := 'Messages';
  WebStringGridChats.Cells[2, 0] := 'Cost';
  WebStringGridChats.Cells[3, 0] := 'Updated';
  
  r := 1;
  for i := 0 to arr.length - 1 do
  begin
    o := TJSObject(arr[i]);
    
    WebStringGridChats.Cells[0, r] := GetStr('title');
    WebStringGridChats.Cells[1, r] := IntToStr(GetInt('message_count'));
    WebStringGridChats.Cells[2, r] := FormatCost('total_cost_usd');
    WebStringGridChats.Cells[3, r] := GetStr('updated_at');
    
    // Store session data in the row for later retrieval
    asm
      var grid = this.WebStringGridChats;
      if (!grid.Objects) grid.Objects = {};
      grid.Objects[r] = {
        session_id: o.session_id,
        session_key: o.session_key
      };
    end;
    
    Inc(r);
  end;
  
  asm
    console.log('Grid populated with', arr.length, 'chats');
  end;
end;

procedure TForm1.HandleChatsError(const AError: string);
begin
  ShowMessage('Failed to load chats: ' + AError);
end;

procedure TForm1.WebStringGridChatsClick(Sender: TObject);
var
  Row: Integer;
  SessionId: Integer;
  Title: string;
begin
  Row := WebStringGridChats.Row;
  
  // Skip header row
  if Row < 1 then
    Exit;
  
  // Get session info from the clicked row
  Title := WebStringGridChats.Cells[0, Row];
  
  // Extract session_id from the grid data
  // We'll need to store this when populating the grid
  asm
    var grid = this.WebStringGridChats;
    // Get the session_id stored in the row's data
    if (grid.Objects && grid.Objects[Row]) {
      SessionId = grid.Objects[Row].session_id;
      this.FCurrentSessionKey = grid.Objects[Row].session_key;
    }
  end;
  
  FCurrentSessionId := SessionId;
  
  // Update chat header
  WebLabelChatTitle.Caption := Title;
  
  // Clear message input
  WebEditMessage.Text := '';
  
  // Load messages for this session
  LoadChatMessages(SessionId);
end;

procedure TForm1.WebButtonSendClick(Sender: TObject);
var
  Message: string;
begin
  Message := Trim(WebEditMessage.Text);
  
  if Message = '' then
  begin
    ShowMessage('Please enter a message');
    Exit;
  end;
  
  if FCurrentSessionId = 0 then
  begin
    ShowMessage('Please select a chat first');
    Exit;
  end;
  
  // Send message to n8n
  SendChatMessage(FCurrentSessionId, Message);
  
  // Clear input
  WebEditMessage.Text := '';
end;

procedure TForm1.LoadChatMessages(ASessionId: Integer);
var
  URL: string;
begin
  URL := 'https://n8n.wilsea.com/webhook/oversightData' +
         '?action=getChatItems&sessionId=' + IntToStr(ASessionId);
  
  asm
    console.log('Loading messages for session:', ASessionId);
    
    var form = this;
    
    fetch(URL, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit'
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('HTTP error ' + response.status);
      }
      return response.text();
    })
    .then(function(responseText) {
      console.log('Messages response:', responseText);
      form.DisplayMessages(responseText);
    })
    .catch(function(error) {
      console.error('Messages fetch error:', error);
      form.ShowMessage('Failed to load messages: ' + error.message);
    });
  end;
end;

procedure TForm1.DisplayMessages(const AResponse: string);
begin
  asm
    var data = JSON.parse(AResponse);
    var container = document.getElementById('chatMessages');
    
    if (!container) {
      console.error('Chat messages container not found');
      return;
    }
    
    // Clear existing messages
    container.innerHTML = '';
    
    // Create scrollable wrapper
    var wrapper = document.createElement('div');
    wrapper.style.cssText = 'padding: 10px; overflow-y: auto; height: 100%; background-color: #e5ddd5;';
    
    // Add messages
    for (var i = 0; i < data.length; i++) {
      var msg = data[i];
      var isUser = msg.role === 'user';
      
      // Create message container
      var msgDiv = document.createElement('div');
      msgDiv.style.cssText = 'display: flex; margin-bottom: 10px; ' + 
        (isUser ? 'justify-content: flex-end;' : 'justify-content: flex-start;');
      
      // Create message bubble
      var bubble = document.createElement('div');
      bubble.style.cssText = 'max-width: 70%; padding: 8px 12px; border-radius: 8px; ' +
        'box-shadow: 0 1px 2px rgba(0,0,0,0.1); ' +
        (isUser 
          ? 'background-color: #dcf8c6; margin-left: auto;' 
          : 'background-color: white; margin-right: auto;');
      
      // Add message content
      var content = document.createElement('div');
      content.textContent = msg.content;
      content.style.cssText = 'word-wrap: break-word; margin-bottom: 4px;';
      
      // Add timestamp
      var time = document.createElement('div');
      time.textContent = new Date(msg.created_at).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
      time.style.cssText = 'font-size: 11px; color: #667781; text-align: right;';
      
      bubble.appendChild(content);
      bubble.appendChild(time);
      msgDiv.appendChild(bubble);
      wrapper.appendChild(msgDiv);
    }
    
    container.appendChild(wrapper);
    
    // Scroll to bottom
    wrapper.scrollTop = wrapper.scrollHeight;
  end;
end;

procedure TForm1.SendChatMessage(ASessionId: Integer; const AMessage: string);
var
  URL: string;
begin
  URL := 'https://n8n.wilsea.com/webhook/oversightChat';
  
  asm
    console.log('Sending message to session:', ASessionId);
    
    var form = this;
    var payload = {
      question: AMessage,
      sessionKey: form.FCurrentSessionKey || ('sess-' + String(ASessionId)),
      clientAccountId: form.FClientAccountId
    };
    
    fetch(URL, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('HTTP error ' + response.status);
      }
      return response.text();
    })
    .then(function(responseText) {
      console.log('Send message response:', responseText);
      var data = null;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        console.error('Failed to parse oversightChat response as JSON', e);
      }
      if (data && typeof data.sessionId !== 'undefined') {
        form.FCurrentSessionId = data.sessionId;
        if (data.sessionKey) {
          form.FCurrentSessionKey = data.sessionKey;
        }
        // Reload messages to show the new message and response
        form.LoadChatMessages(data.sessionId);
      } else if (ASessionId) {
        form.LoadChatMessages(ASessionId);
      }
    })
    .catch(function(error) {
      console.error('Send message error:', error);
      form.ShowMessage('Failed to send message: ' + (error.message || error.toString()));
    });
  end;
end;

procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPageControl1 := TPageControl.Create(Self);
  Tab1 := TTabSheet.Create(Self);
  Grid := TResponsiveGridPanel.Create(Self);
  WebPanelCustomer := TPanel.Create(Self);
  WebStringGridChats := TStringGrid.Create(Self);
  WebGridPanelSearch := TGridPanel.Create(Self);
  WebButtonNewChat := TButton.Create(Self);
  WebSearchEditChats := TSearchEdit.Create(Self);
  WebPanelChats := TPanel.Create(Self);
  WebPanelChatHeader := TPanel.Create(Self);
  WebLabelChatTitle := TLabel.Create(Self);
  WebPanelChatInput := TPanel.Create(Self);
  WebEditMessage := TEdit.Create(Self);
  WebButtonSend := TButton.Create(Self);
  WebHTMLDiv1 := THTMLDiv.Create('chatMessages');
  Tab2 := TTabSheet.Create(Self);
  WebScrollBox1 := TScrollBox.Create(Self);
  WebResponsiveGrid1 := TResponsiveGrid.Create('WebResponsiveGrid1');
  Tab3 := TTabSheet.Create(Self);
  TabAccount := TTabSheet.Create(Self);
  WebHTMLDivPayPal := THTMLDiv.Create('paypal-button-container');
  WebGridPanelTop := TGridPanel.Create(Self);
  WebLabelContactName := TLabel.Create(Self);
  WebLabelCompanyName := TLabel.Create(Self);
  WebLabelBalance := TLabel.Create(Self);
  WebButtonLogin := TButton.Create(Self);
  WebHttpRequestGetClient := THttpRequest.Create(Self);

  WebPageControl1.BeforeLoadDFMValues;
  Tab1.BeforeLoadDFMValues;
  Grid.BeforeLoadDFMValues;
  WebPanelCustomer.BeforeLoadDFMValues;
  WebStringGridChats.BeforeLoadDFMValues;
  WebGridPanelSearch.BeforeLoadDFMValues;
  WebButtonNewChat.BeforeLoadDFMValues;
  WebSearchEditChats.BeforeLoadDFMValues;
  WebPanelChats.BeforeLoadDFMValues;
  WebPanelChatHeader.BeforeLoadDFMValues;
  WebLabelChatTitle.BeforeLoadDFMValues;
  WebPanelChatInput.BeforeLoadDFMValues;
  WebEditMessage.BeforeLoadDFMValues;
  WebButtonSend.BeforeLoadDFMValues;
  WebHTMLDiv1.BeforeLoadDFMValues;
  Tab2.BeforeLoadDFMValues;
  WebScrollBox1.BeforeLoadDFMValues;
  WebResponsiveGrid1.BeforeLoadDFMValues;
  Tab3.BeforeLoadDFMValues;
  TabAccount.BeforeLoadDFMValues;
  WebHTMLDivPayPal.BeforeLoadDFMValues;
  WebGridPanelTop.BeforeLoadDFMValues;
  WebLabelContactName.BeforeLoadDFMValues;
  WebLabelCompanyName.BeforeLoadDFMValues;
  WebLabelBalance.BeforeLoadDFMValues;
  WebButtonLogin.BeforeLoadDFMValues;
  WebHttpRequestGetClient.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Width := 640;
    Height := 480;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebPageControl1.SetParentComponent(Self);
    WebPageControl1.Name := 'WebPageControl1';
    WebPageControl1.Left := 0;
    WebPageControl1.Top := 40;
    WebPageControl1.Width := 640;
    WebPageControl1.Height := 440;
    WebPageControl1.ElementClassName := 'nav nav-tabs';
    WebPageControl1.Align := alClient;
    WebPageControl1.ChildOrder := 2;
    WebPageControl1.ElementTabClassName := 'nav-link';
    WebPageControl1.ElementTabActiveClassName := 'nav-link active';
    WebPageControl1.ElementTabItemClassName := 'nav-item';
    WebPageControl1.ElementFont := efCSS;
    WebPageControl1.TabIndex := 0;
    WebPageControl1.TabOrder := 0;
    Tab1.SetParentComponent(WebPageControl1);
    Tab1.Name := 'Tab1';
    Tab1.Left := 0;
    Tab1.Top := 20;
    Tab1.Width := 640;
    Tab1.Height := 420;
    Tab1.Caption := 'Chats';
    Tab1.ChildOrder := 3;
    Tab1.ElementFont := efCSS;
    Grid.SetParentComponent(Tab1);
    Grid.Name := 'Grid';
    Grid.Left := 0;
    Grid.Top := 0;
    Grid.Width := 640;
    Grid.Height := 420;
    Grid.Align := alClient;
    Grid.ControlCollection.Clear;
    with Grid.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebPanelCustomer;
    end;
    with Grid.ControlCollection.Add do
    begin
      Column := 1;
      Row := 0;
      Control := WebPanelChats;
    end;
    Grid.Color := clWhite;
    Grid.ElementFont := efCSS;
    Grid.ElementPosition := epRelative;
    Grid.Layout.Clear;
    with Grid.Layout.Add do
    begin
      Description := 'Smartphone';
      Style := '1fr';
      Width := 575;
    end;
    with Grid.Layout.Add do
    begin
      Description := 'Tablet';
      Style := '1fr 2fr';
      Width := 768;
    end;
    with Grid.Layout.Add do
    begin
      Description := 'Desktop';
      Style := '1fr 2fr';
      Width := 991;
    end;
    with Grid.Layout.Add do
    begin
      Description := 'Large Desktop';
      Style := '1fr 2fr';
      Width := 1199;
    end;
    WebPanelCustomer.SetParentComponent(Grid);
    WebPanelCustomer.Name := 'WebPanelCustomer';
    WebPanelCustomer.Left := 0;
    WebPanelCustomer.Top := 0;
    WebPanelCustomer.Width := 213;
    WebPanelCustomer.Height := 400;
    WebPanelCustomer.ElementClassName := 'card';
    WebPanelCustomer.HeightStyle := ssPercent;
    WebPanelCustomer.WidthStyle := ssPercent;
    WebPanelCustomer.Align := alClient;
    WebPanelCustomer.ChildOrder := 1;
    WebPanelCustomer.ElementBodyClassName := 'card-body';
    WebPanelCustomer.ElementFont := efCSS;
    WebPanelCustomer.ElementPosition := epRelative;
    WebPanelCustomer.TabOrder := 0;
    WebStringGridChats.SetParentComponent(WebPanelCustomer);
    WebStringGridChats.Name := 'WebStringGridChats';
    WebStringGridChats.Left := 0;
    WebStringGridChats.Top := 80;
    WebStringGridChats.Width := 213;
    WebStringGridChats.Height := 320;
    WebStringGridChats.Align := alClient;
    WebStringGridChats.Anchors := [akLeft,akTop,akRight];
    WebStringGridChats.TabOrder := 0;
    SetEvent(WebStringGridChats, Self, 'OnClick', 'WebStringGridChatsClick');
    WebStringGridChats.ElementFont := efCSS;
    WebStringGridChats.FixedFont.Charset := DEFAULT_CHARSET;
    WebStringGridChats.FixedFont.Color := clWindowText;
    WebStringGridChats.FixedFont.Height := -12;
    WebStringGridChats.FixedFont.Name := 'Segoe UI';
    WebStringGridChats.FixedFont.Style := [];
    WebStringGridChats.RangeEdit.Max := 100.000000000000000000;
    WebStringGridChats.RangeEdit.Step := 1.000000000000000000;
    WebStringGridChats.HeightStyle := ssPercent;
    WebStringGridChats.HeightPercent := 100.000000000000000000;
    WebStringGridChats.WidthPercent := 100.000000000000000000;
    WebGridPanelSearch.SetParentComponent(WebPanelCustomer);
    WebGridPanelSearch.Name := 'WebGridPanelSearch';
    WebGridPanelSearch.Left := 0;
    WebGridPanelSearch.Top := 0;
    WebGridPanelSearch.Width := 213;
    WebGridPanelSearch.Height := 80;
    WebGridPanelSearch.HeightStyle := ssAuto;
    WebGridPanelSearch.WidthStyle := ssAuto;
    WebGridPanelSearch.Align := alTop;
    WebGridPanelSearch.ChildOrder := 1;
    WebGridPanelSearch.ColumnCollection.Clear;
    with WebGridPanelSearch.ColumnCollection.Add do
    begin
      Value := 50;
    end;
    with WebGridPanelSearch.ColumnCollection.Add do
    begin
      Value := 50;
    end;
    WebGridPanelSearch.ControlCollection.Clear;
    with WebGridPanelSearch.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebButtonNewChat;
    end;
    with WebGridPanelSearch.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebSearchEditChats;
    end;
    WebGridPanelSearch.Color := clWhite;
    WebGridPanelSearch.ElementPosition := epIgnore;
    WebGridPanelSearch.GridLineColor := clBlack;
    WebGridPanelSearch.RowCollection.Clear;
    with WebGridPanelSearch.RowCollection.Add do
    begin
      Value := 100;
    end;
    WebButtonNewChat.SetParentComponent(WebGridPanelSearch);
    WebButtonNewChat.Name := 'WebButtonNewChat';
    WebButtonNewChat.Left := 2;
    WebButtonNewChat.Top := 2;
    WebButtonNewChat.Width := 96;
    WebButtonNewChat.Height := 25;
    WebButtonNewChat.Anchors := [];
    WebButtonNewChat.Caption := 'New Chat';
    WebButtonNewChat.ElementClassName := 'btn btn-light';
    WebButtonNewChat.ElementFont := efCSS;
    WebButtonNewChat.ElementPosition := epIgnore;
    WebButtonNewChat.HeightStyle := ssAuto;
    WebButtonNewChat.HeightPercent := 100.000000000000000000;
    WebButtonNewChat.WidthStyle := ssAuto;
    WebButtonNewChat.WidthPercent := 100.000000000000000000;
    WebSearchEditChats.SetParentComponent(WebGridPanelSearch);
    WebSearchEditChats.Name := 'WebSearchEditChats';
    WebSearchEditChats.Left := 109;
    WebSearchEditChats.Top := 2;
    WebSearchEditChats.Width := 121;
    WebSearchEditChats.Height := 22;
    WebSearchEditChats.Anchors := [];
    WebSearchEditChats.ChildOrder := 1;
    WebSearchEditChats.ElementClassName := 'form-control';
    WebSearchEditChats.ElementFont := efCSS;
    WebSearchEditChats.ElementPosition := epIgnore;
    WebSearchEditChats.HeightStyle := ssAuto;
    WebSearchEditChats.HeightPercent := 100.000000000000000000;
    WebSearchEditChats.WidthStyle := ssAuto;
    WebSearchEditChats.WidthPercent := 100.000000000000000000;
    WebPanelChats.SetParentComponent(Grid);
    WebPanelChats.Name := 'WebPanelChats';
    WebPanelChats.Left := 213;
    WebPanelChats.Top := 0;
    WebPanelChats.Width := 427;
    WebPanelChats.Height := 241;
    WebPanelChats.ElementClassName := 'card';
    WebPanelChats.HeightStyle := ssPercent;
    WebPanelChats.WidthStyle := ssPercent;
    WebPanelChats.Align := alClient;
    WebPanelChats.ChildOrder := 1;
    WebPanelChats.ElementBodyClassName := 'card-body';
    WebPanelChats.ElementFont := efCSS;
    WebPanelChats.ElementPosition := epIgnore;
    WebPanelChats.TabOrder := 1;
    WebPanelChatHeader.SetParentComponent(WebPanelChats);
    WebPanelChatHeader.Name := 'WebPanelChatHeader';
    WebPanelChatHeader.Left := 0;
    WebPanelChatHeader.Top := 0;
    WebPanelChatHeader.Width := 427;
    WebPanelChatHeader.Height := 48;
    WebPanelChatHeader.ElementClassName := 'bg-light border-bottom';
    WebPanelChatHeader.Align := alTop;
    WebPanelChatHeader.ElementFont := efCSS;
    WebPanelChatHeader.TabOrder := 0;
    WebLabelChatTitle.SetParentComponent(WebPanelChatHeader);
    WebLabelChatTitle.Name := 'WebLabelChatTitle';
    WebLabelChatTitle.Left := 16;
    WebLabelChatTitle.Top := 14;
    WebLabelChatTitle.Width := 96;
    WebLabelChatTitle.Height := 18;
    WebLabelChatTitle.Caption := 'Select a chat';
    WebLabelChatTitle.ElementFont := efCSS;
    WebLabelChatTitle.Font.Charset := DEFAULT_CHARSET;
    WebLabelChatTitle.Font.Color := clWindowText;
    WebLabelChatTitle.Font.Height := -15;
    WebLabelChatTitle.Font.Name := 'Tahoma';
    WebLabelChatTitle.Font.Style := [fsBold];
    WebLabelChatTitle.HeightPercent := 100.000000000000000000;
    WebLabelChatTitle.ParentFont := False;
    WebLabelChatTitle.WidthPercent := 100.000000000000000000;
    WebPanelChatInput.SetParentComponent(WebPanelChats);
    WebPanelChatInput.Name := 'WebPanelChatInput';
    WebPanelChatInput.Left := 0;
    WebPanelChatInput.Top := 193;
    WebPanelChatInput.Width := 427;
    WebPanelChatInput.Height := 48;
    WebPanelChatInput.ElementClassName := 'border-top';
    WebPanelChatInput.Align := alBottom;
    WebPanelChatInput.ElementFont := efCSS;
    WebPanelChatInput.TabOrder := 1;
    WebEditMessage.SetParentComponent(WebPanelChatInput);
    WebEditMessage.Name := 'WebEditMessage';
    WebEditMessage.Left := 8;
    WebEditMessage.Top := 10;
    WebEditMessage.Width := 345;
    WebEditMessage.Height := 28;
    WebEditMessage.ElementClassName := 'form-control';
    WebEditMessage.ElementFont := efCSS;
    WebEditMessage.HeightPercent := 100.000000000000000000;
    WebEditMessage.Text := 'Type a message...';
    WebEditMessage.WidthPercent := 100.000000000000000000;
    WebButtonSend.SetParentComponent(WebPanelChatInput);
    WebButtonSend.Name := 'WebButtonSend';
    WebButtonSend.Left := 359;
    WebButtonSend.Top := 10;
    WebButtonSend.Width := 60;
    WebButtonSend.Height := 28;
    WebButtonSend.Caption := 'Send';
    WebButtonSend.ElementClassName := 'btn btn-primary';
    WebButtonSend.ElementFont := efCSS;
    WebButtonSend.HeightPercent := 100.000000000000000000;
    WebButtonSend.TabOrder := 1;
    WebButtonSend.WidthPercent := 100.000000000000000000;
    SetEvent(WebButtonSend, Self, 'OnClick', 'WebButtonSendClick');
    WebHTMLDiv1.SetParentComponent(WebPanelChats);
    WebHTMLDiv1.Name := 'WebHTMLDiv1';
    WebHTMLDiv1.Left := 0;
    WebHTMLDiv1.Top := 48;
    WebHTMLDiv1.Width := 427;
    WebHTMLDiv1.Height := 145;
    WebHTMLDiv1.ElementClassName := 'chat-messages-container';
    WebHTMLDiv1.Align := alClient;
    WebHTMLDiv1.ChildOrder := 2;
    WebHTMLDiv1.ElementFont := efCSS;
    WebHTMLDiv1.HTML.BeginUpdate;
    try
      WebHTMLDiv1.HTML.Clear;
      WebHTMLDiv1.HTML.Add('<div style="padding: 10px; overflow-y: auto; height: 100%; background-color: #e5ddd5;">');
      WebHTMLDiv1.HTML.Add('  <p style="text-align: center; color: #999;">Select a chat to view messages</p>');
      WebHTMLDiv1.HTML.Add('</div>');
    finally
      WebHTMLDiv1.HTML.EndUpdate;
    end;
    WebHTMLDiv1.Role := '';
    Tab2.SetParentComponent(WebPageControl1);
    Tab2.Name := 'Tab2';
    Tab2.Left := 0;
    Tab2.Top := 20;
    Tab2.Width := 640;
    Tab2.Height := 420;
    Tab2.Caption := 'Tab2';
    Tab2.ChildOrder := 1;
    Tab2.ElementFont := efCSS;
    WebScrollBox1.SetParentComponent(Tab2);
    WebScrollBox1.Name := 'WebScrollBox1';
    WebScrollBox1.Left := 0;
    WebScrollBox1.Top := 0;
    WebScrollBox1.Width := 640;
    WebScrollBox1.Height := 420;
    WebScrollBox1.ElementClassName := 'gridScroll';
    WebScrollBox1.Align := alClient;
    WebScrollBox1.BorderStyle := bsSingle;
    WebScrollBox1.ChildOrder := 1;
    WebResponsiveGrid1.SetParentComponent(WebScrollBox1);
    WebResponsiveGrid1.Name := 'WebResponsiveGrid1';
    WebResponsiveGrid1.Left := 0;
    WebResponsiveGrid1.Top := 0;
    WebResponsiveGrid1.Width := 640;
    WebResponsiveGrid1.Height := 364;
    WebResponsiveGrid1.ElementClassName := 'cars-grid';
    WebResponsiveGrid1.HeightStyle := ssAuto;
    WebResponsiveGrid1.Align := alTop;
    WebResponsiveGrid1.ElementFont := efCSS;
    WebResponsiveGrid1.ElementPosition := epRelative;
    WebResponsiveGrid1.Options.ItemHeight := 200;
    WebResponsiveGrid1.Options.ItemWidthMin := 200;
    Tab3.SetParentComponent(WebPageControl1);
    Tab3.Name := 'Tab3';
    Tab3.Left := 0;
    Tab3.Top := 20;
    Tab3.Width := 640;
    Tab3.Height := 420;
    Tab3.Caption := 'Tab3';
    Tab3.ChildOrder := 2;
    Tab3.ElementFont := efCSS;
    TabAccount.SetParentComponent(WebPageControl1);
    TabAccount.Name := 'TabAccount';
    TabAccount.Left := 0;
    TabAccount.Top := 20;
    TabAccount.Width := 640;
    TabAccount.Height := 420;
    TabAccount.Caption := 'Account';
    TabAccount.ChildOrder := 3;
    TabAccount.ElementFont := efCSS;
    WebHTMLDivPayPal.SetParentComponent(TabAccount);
    WebHTMLDivPayPal.Name := 'WebHTMLDivPayPal';
    WebHTMLDivPayPal.Left := 107;
    WebHTMLDivPayPal.Top := 112;
    WebHTMLDivPayPal.Width := 158;
    WebHTMLDivPayPal.Height := 85;
    WebHTMLDivPayPal.ElementFont := efCSS;
    WebHTMLDivPayPal.Role := '';
    WebGridPanelTop.SetParentComponent(Self);
    WebGridPanelTop.Name := 'WebGridPanelTop';
    WebGridPanelTop.Left := 0;
    WebGridPanelTop.Top := 0;
    WebGridPanelTop.Width := 640;
    WebGridPanelTop.Height := 40;
    WebGridPanelTop.HeightStyle := ssAuto;
    WebGridPanelTop.WidthStyle := ssAuto;
    WebGridPanelTop.Align := alTop;
    WebGridPanelTop.ChildOrder := 1;
    WebGridPanelTop.ColumnCollection.Clear;
    with WebGridPanelTop.ColumnCollection.Add do
    begin
      Value := 50;
    end;
    with WebGridPanelTop.ColumnCollection.Add do
    begin
      Value := 50;
    end;
    WebGridPanelTop.ControlCollection.Clear;
    with WebGridPanelTop.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebLabelContactName;
    end;
    with WebGridPanelTop.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebLabelCompanyName;
    end;
    with WebGridPanelTop.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebLabelBalance;
    end;
    with WebGridPanelTop.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebButtonLogin;
    end;
    WebGridPanelTop.Color := clWhite;
    WebGridPanelTop.ElementPosition := epIgnore;
    WebGridPanelTop.GridLineColor := clBlack;
    WebGridPanelTop.RowCollection.Clear;
    with WebGridPanelTop.RowCollection.Add do
    begin
      Value := 50;
    end;
    with WebGridPanelTop.RowCollection.Add do
    begin
      Value := 50;
    end;
    WebLabelContactName.SetParentComponent(WebGridPanelTop);
    WebLabelContactName.Name := 'WebLabelContactName';
    WebLabelContactName.Left := 2;
    WebLabelContactName.Top := 2;
    WebLabelContactName.Width := 79;
    WebLabelContactName.Height := 18;
    WebLabelContactName.Anchors := [];
    WebLabelContactName.Caption := 'Client details';
    WebLabelContactName.ElementFont := efCSS;
    WebLabelContactName.HeightStyle := ssAuto;
    WebLabelContactName.HeightPercent := 100.000000000000000000;
    WebLabelContactName.WidthPercent := 100.000000000000000000;
    WebLabelCompanyName.SetParentComponent(WebGridPanelTop);
    WebLabelCompanyName.Name := 'WebLabelCompanyName';
    WebLabelCompanyName.Left := 322;
    WebLabelCompanyName.Top := 2;
    WebLabelCompanyName.Width := 79;
    WebLabelCompanyName.Height := 18;
    WebLabelCompanyName.Anchors := [];
    WebLabelCompanyName.Caption := 'Client details';
    WebLabelCompanyName.ElementFont := efCSS;
    WebLabelCompanyName.HeightStyle := ssAuto;
    WebLabelCompanyName.HeightPercent := 100.000000000000000000;
    WebLabelCompanyName.WidthPercent := 100.000000000000000000;
    WebLabelBalance.SetParentComponent(WebGridPanelTop);
    WebLabelBalance.Name := 'WebLabelBalance';
    WebLabelBalance.Left := 2;
    WebLabelBalance.Top := 22;
    WebLabelBalance.Width := 79;
    WebLabelBalance.Height := 18;
    WebLabelBalance.Anchors := [];
    WebLabelBalance.Caption := 'Client details';
    WebLabelBalance.ElementFont := efCSS;
    WebLabelBalance.HeightStyle := ssAuto;
    WebLabelBalance.HeightPercent := 100.000000000000000000;
    WebLabelBalance.WidthPercent := 100.000000000000000000;
    WebButtonLogin.SetParentComponent(WebGridPanelTop);
    WebButtonLogin.Name := 'WebButtonLogin';
    WebButtonLogin.Left := 322;
    WebButtonLogin.Top := 22;
    WebButtonLogin.Width := 96;
    WebButtonLogin.Height := 25;
    WebButtonLogin.Anchors := [];
    WebButtonLogin.Caption := 'Log In';
    WebButtonLogin.ChildOrder := 3;
    WebButtonLogin.ElementClassName := 'btn btn-light';
    WebButtonLogin.ElementFont := efCSS;
    WebButtonLogin.ElementPosition := epIgnore;
    WebButtonLogin.HeightStyle := ssAuto;
    WebButtonLogin.HeightPercent := 100.000000000000000000;
    WebButtonLogin.WidthStyle := ssAuto;
    WebButtonLogin.WidthPercent := 100.000000000000000000;
    SetEvent(WebButtonLogin, Self, 'OnClick', 'WebButtonLoginClick');
    WebHttpRequestGetClient.SetParentComponent(Self);
    WebHttpRequestGetClient.Name := 'WebHttpRequestGetClient';
    WebHttpRequestGetClient.Left := 544;
    WebHttpRequestGetClient.Top := 8;
  finally
    WebPageControl1.AfterLoadDFMValues;
    Tab1.AfterLoadDFMValues;
    Grid.AfterLoadDFMValues;
    WebPanelCustomer.AfterLoadDFMValues;
    WebStringGridChats.AfterLoadDFMValues;
    WebGridPanelSearch.AfterLoadDFMValues;
    WebButtonNewChat.AfterLoadDFMValues;
    WebSearchEditChats.AfterLoadDFMValues;
    WebPanelChats.AfterLoadDFMValues;
    WebPanelChatHeader.AfterLoadDFMValues;
    WebLabelChatTitle.AfterLoadDFMValues;
    WebPanelChatInput.AfterLoadDFMValues;
    WebEditMessage.AfterLoadDFMValues;
    WebButtonSend.AfterLoadDFMValues;
    WebHTMLDiv1.AfterLoadDFMValues;
    Tab2.AfterLoadDFMValues;
    WebScrollBox1.AfterLoadDFMValues;
    WebResponsiveGrid1.AfterLoadDFMValues;
    Tab3.AfterLoadDFMValues;
    TabAccount.AfterLoadDFMValues;
    WebHTMLDivPayPal.AfterLoadDFMValues;
    WebGridPanelTop.AfterLoadDFMValues;
    WebLabelContactName.AfterLoadDFMValues;
    WebLabelCompanyName.AfterLoadDFMValues;
    WebLabelBalance.AfterLoadDFMValues;
    WebButtonLogin.AfterLoadDFMValues;
    WebHttpRequestGetClient.AfterLoadDFMValues;
  end;
end;

end.

